import { Button, Space, Table, Tag, message } from "antd";
import axios from "axios";
import moment from "moment";
import React from "react";
import { useQuery, useQueryClient } from "react-query";
import { serverUrl } from "../../../../nestserver";

const AssignmentList = () => {
  const queryClient = useQueryClient();

  const authHeaders = () => ({
    Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
  });

  // No studentId param: the server resolves the logged-in student itself.
  const assignments = useQuery(["assessment/by-student", "self"], () =>
    axios({
      method: "get",
      url: `${serverUrl}/exam-v2/by-student`,
      headers: authHeaders(),
    }).then((res) => res.data),
  );

  const handleAcknowledge = async (record) => {
    try {
      await axios({
        method: "patch",
        url: `${serverUrl}/exam-v2/marks/${record?._id}/acknowledge`,
        headers: authHeaders(),
      });
      message.success("Acknowledged");
      queryClient.invalidateQueries(["assessment/by-student", "self"]);
    } catch (e) {
      const reason = e?.response?.data?.message;
      message.error(
        (Array.isArray(reason) ? reason[0] : reason) ||
          "Could not acknowledge. Please try again.",
      );
    }
  };

  const columns = [
    {
      title: "Subject",
      key: "subject",
      align: "center",
      render: (record) => (
        <div className="text-base text-center capitalize">
          {record?.exam?.subject?.name || "--"}
        </div>
      ),
    },
    {
      title: "Exam",
      key: "assessment",
      align: "center",
      render: (record) => (
        <div className="text-base text-center capitalize">
          {record?.exam?.name || "--"}
        </div>
      ),
    },
    {
      title: "Marks",
      key: "marks",
      align: "center",
      render: (record) => (
        <div className="text-base text-center font-semibold">
          {record?.marks_obtained ?? 0} / {record?.total_marks ?? 0}
        </div>
      ),
    },
    {
      title: "Remarks",
      key: "remarks",
      align: "center",
      render: (record) => (
        <div className="text-base text-center">{record?.remarks || "--"}</div>
      ),
    },
    {
      title: "Shared On",
      key: "notified_at",
      align: "center",
      render: (record) => (
        <div className="text-base text-center">
          {record?.notified_at
            ? moment(record.notified_at).format("DD MMM YYYY, hh:mm A")
            : "--"}
        </div>
      ),
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      render: (record) =>
        record?.status === "acknowledged" ? (
          <Tag color="green">Acknowledged</Tag>
        ) : (
          <Space size="middle">
            <Tag color="blue">New</Tag>
            <Button size="small" onClick={() => handleAcknowledge(record)}>
              Acknowledge
            </Button>
          </Space>
        ),
    },
  ];

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md p-8 w-full "
      >
        <div className="text-2xl text-orange-500 font-semibold pb-6">
          Exam Results
        </div>
        <div className="py-5">
          <Table
            rowKey="_id"
            loading={assignments.isLoading}
            columns={columns}
            dataSource={
              assignments?.isSuccess && assignments?.data
                ? assignments.data
                : []
            }
            locale={{
              emptyText: "No marks have been shared with you yet.",
            }}
            pagination={true}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignmentList;
